import { render } from "./mar.vue?vue&type=template&id=753151f4"
const script = {}

import "./mar.vue?vue&type=style&index=0&id=753151f4&lang=scss"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__